import React,{ useEffect,useState } from "react";
import "./App.css";
import logo from "./thinkpad-logo.svg";
// import qr from window.location.origin +"/img/qrcode.svg";

import { sideMenu } from "./sideMenu";
import { MenuItem } from './MultiLevel';
import { httprequesthandler } from './httprequesthandler';
function useForceUpdate(){
   const [value, setValue] = useState(0); // integer state
   return () => setValue(value => value + 1); // update state to force render
}
function App() {
   const forceUpdate = useForceUpdate();
   const [orentation,setOrentation] = useState((window.mob || window.isipad) && window.innerHeight > window.innerWidth ? 90 : 0)

   const [skin_menu,setskin_menu] = useState(false);
   const mobIpadPotrait = (window.mob && orentation == 90) || (window.isipad && orentation == 90);
   const [appData, setAppData] = useState([]);
   const [appDataDummy, setappDataDummy] = useState([]);
   

   const datafetch = () => {
      httprequesthandler('data.json').then(function (data) {
          var content;
          content = data.EN.filter(val => val.menuVisibility !== 'hide')
            return content;
      }).then(function (content) {

          setAppData(content);
          

      });
  }

  useEffect(() => {
   if (appData.length == 0) {
       datafetch();
   }
}, []);

window.globalAppData = appData
useEffect(() => {
   setappDataDummy(appData);
}, [appData])
   const handleClick = (divname) => {
      const collection = document.getElementsByClassName("mob_skin_icon");
      for (let i = 0; i < collection.length; i++) {
         collection[i].classList.remove('active');
      }
      document.getElementById(divname).classList.add('active');
      window.changeSkin(divname);
   }
  
   useEffect(() => {
      window.addEventListener("orientationchange",event => {
         if (window.innerHeight > window.innerWidth) {
            setOrentation(0);
         } else {
            setOrentation(90);

         }
      });
      
   },[]);

    return (
      <>
         <div id="leftMenu">
            <div className="logo_div">
               <img className="" alt="" src={logo} />
            </div>
            <div className="title_div" style={{width: '210px'}}>
                <h2>ThinkPad T14s Gen 6<br></br>Advanced by AMD</h2>
            </div>          
            {/* <div className="main_menu">
               {sideMenu.map((item,key) =>
                  <MenuItem setskin_menu={setskin_menu} key={key} item={item} />
               )}
            </div> */}
            
            <div id="scroll">
            <div className="main_menu">
            {appData.map((item,key) =>{
                return  <MenuItem setskin_menu={setskin_menu} key={key} item={item} />
            }
               )}

            </div>
            { (!window.mob && !window.isipad) && <div className="QR_div" id='qrCode'>
               <h5>SCAN QR CODE</h5>
               <img className="qrImg" alt="" src="./img/qrcode.svg" />
                <p>View the ThinkPad T14s Gen 6 advanced by AMD in your environment</p>

               <div id="snapdragon_logo_text_wrapper">
                  <div id="snapdragon_logo_container">
                     <div id="exterior_snapdragon_logo">
                        <img src="img/snapdragon-badge.png" alt="" />
                     </div>
                  </div>
               </div>

            </div> }
            </div>
         </div>
      </>
   );
}


export default App;
